import type { GrantEntry } from "../../../../shared/rbac/roles";

type ScopeGrantRow = {
  userId?: string | null;
  userGroupId?: string | null;
  serviceAccountId?: string | null;
  builtinRoleId?: string | null;
  customRoleId?: string | null;
};

export type AccessPrincipal =
  | { userId: string; userGroupId?: never; serviceAccountId?: never }
  | { userGroupId: string; userId?: never; serviceAccountId?: never }
  | { serviceAccountId: string; userId?: never; userGroupId?: never };

export function isPrincipalGrant(
  grant: ScopeGrantRow,
  principal: AccessPrincipal
) {
  return principal.userId != null
    ? grant.userId === principal.userId
    : principal.userGroupId != null
      ? grant.userGroupId === principal.userGroupId
      : grant.serviceAccountId === principal.serviceAccountId;
}

type RoleRef = { builtinRoleId?: string; customRoleId?: string };

export function buildScopeDesired(
  scopeGrants: readonly ScopeGrantRow[],
  principal: AccessPrincipal,
  desiredRoles: readonly RoleRef[]
): GrantEntry[] {
  return [
    ...scopeGrants
      .filter((g) => !isPrincipalGrant(g, principal))
      .map((g) => ({
        userId: g.userId ?? undefined,
        userGroupId: g.userGroupId ?? undefined,
        serviceAccountId: g.serviceAccountId ?? undefined,
        builtinRoleId: g.builtinRoleId ?? undefined,
        customRoleId: g.customRoleId ?? undefined,
      })),
    ...desiredRoles.map((r) => ({
      ...principal,
      builtinRoleId: r.builtinRoleId,
      customRoleId: r.customRoleId,
    })),
  ];
}
